import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $width?: string }>`
  position: relative;
  min-width: 60px;
  padding: 0 17px 0 0;
  display: inline-block;
  ${({ $width }) =>
    $width &&
    css`
      width: ${$width};
    `}

  &::after {
    content: '';
    position: absolute;
    top: 11px;
    right: 5px;
    display: block;
    width: 7px;
    height: 5px;
    background-image: url('/images/ico-tiny-dropdown.svg');
    background-size: 7px 5px;
  }
`;

export const ButtonDropDown = styled.button`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: none;
  border: none;
  z-index: 5;
`;

export const SelectedText = styled.div`
  display: block;
  height: 26px;
  line-height: 26px;
  color: ${({ theme }) => theme.colors.greynavy300};
  font-size: ${({ theme }) => theme.fontSize.B3};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  text-align: right;
`;

export const Placeholder = styled(SelectedText)`
  color: ${({ theme }) => theme.colors.gray600};
  overflow: hidden;
`;

export const NoData = styled(SelectedText)`
  color: ${({ theme }) => theme.colors.gray900};
`;
